import posthog from 'posthog-js';

/**
 * Track a PostHog event with properties.
 * Only sends if PostHog is loaded.
 *
 * @param {string} event - Event name
 * @param {object} props - Event properties
 */
export const track = (event, props = {}) => {
  if (posthog.__loaded) {
    posthog.capture(event, props);
  }
};

/**
 * Build an app URL with PostHog distinct_id and UTM parameters.
 * This links the landing page session to the app session.
 *
 * @param {string} url - Base app URL
 * @returns {string} URL with ph_did and UTM parameters
 */
export function appUrlWithId(url) {
  const u = new URL(url);

  // Add PostHog distinct_id to link sessions
  if (posthog.__loaded) {
    u.searchParams.set('ph_did', posthog.get_distinct_id());
  }

  // Propagate current UTM parameters
  ['utm_source', 'utm_medium', 'utm_campaign'].forEach((key) => {
    const value = new URLSearchParams(window.location.search).get(key);
    if (value) {
      u.searchParams.set(key, value);
    }
  });

  // Set default UTMs if none exist
  if (!u.searchParams.get('utm_source')) {
    u.searchParams.set('utm_source', 'soroswap_landing');
    u.searchParams.set('utm_medium', 'cta');
  }

  return u.toString();
}

/**
 * Extract email domain from an email address.
 * Used to track contact form submissions without storing the full email in event properties.
 *
 * @param {string} email - Email address
 * @returns {string} Domain part of the email (e.g., 'gmail.com')
 */
export function getEmailDomain(email) {
  if (!email || typeof email !== 'string') return '';
  const parts = email.split('@');
  return parts.length === 2 ? parts[1] : '';
}
